import { render, staticRenderFns } from "./mine_people.vue?vue&type=template&id=f3271074&lang=pug&"
import script from "./mine_people.vue?vue&type=script&lang=js&"
export * from "./mine_people.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports